import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/inventorySlots/useInventorySlotQueryKeys.ts
var t = e("inventory-slots", {
	host: (e, t, n) => e ? t ? n ? [
		"host",
		e,
		t,
		n.from,
		n.to
	] : [
		"host",
		e,
		t
	] : ["host", e] : ["host"],
	listingAvailability: (e, t, n) => e ? t ? [
		"listing",
		"availability",
		e,
		t.from,
		t.to,
		n ?? 1
	] : [
		"listing",
		"availability",
		e
	] : ["listing", "availability"],
	listingDetail: (e) => e ? [
		"listing",
		"detail",
		e
	] : ["listing", "detail"]
});
//#endregion
export { t as inventorySlotQueryKeys };
